import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import { P } from 'sushiweb/Typography/Text';
import Input from 'sushiweb/InputTypes/Input';

export const StyledP = styled(P)`
  font-size: 1.8rem;
  font-weight: 400;
  color: '#1C1C1C';
  margin-bottom: 1.5rem;
`;

export const CreateButtonWrapper = styled.div`
  margin: auto;
  display: flex;
  justify-content: end;
  padding: 5px 25px 25px 25px;
`;

export const HearderInfoWrapper = styled.div`
  padding: 0.5rem 2rem 1rem 2.5rem;
  display: column;
`;

export const HearderInfoItem = styled.div`
  color: ${grey.z500};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

HearderInfoItem.PlainText = styled.div`
  padding-left: 2px;
`;

export const FormWrapper = styled.div`
  margin-top: 1rem;
  border-top: 0.1rem solid ${grey.z200};
  padding: 2rem 2rem 0rem 2rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
  p {
    font-size: 1.6rem;
    font-weight: 400;
    color: ${grey.z700};
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const OnlinePaymentsGap = styled.div`
  width: 450px;
`;
